import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/supplier-bills/investors/form PUTs `{name, note}` only — `amount` is
 * create-only (it seeds the opening balance), so neither it nor the derived
 * `balance` column is editable here.
 */
export default defineInlineEdit({
  api: "investors",
  permission: "investors_edit",
  hydrate: true,
  toPayload: (detail) => ({
    name: detail.name ?? "",
    note: detail.note ?? "",
  }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
    note: { label: "الملاحظة", type: "text" },
  },
});
